export default {
  name: 'BankListExpand',
  props: {
    data: Object
  },
  data () {
    return {
      loading: true,
      tableItems: null,
      paging: { limit: 20, page: 1, total: 0, pages: 0 }
    }
  },
  computed: {
    tableHeaders () {
      return [
        { key: 'accountNumber', label: this.$t('bank.accountNumber') },
        { key: 'name', label: this.$t('client.name'), type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'api_id' } }
      ];
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      const self = this;
      const reqPath = 'bank/accounts/' + this.data.swift + '?perPage=' + this.paging.limit + '&page=' + this.paging.page;
      this.currentReq = this.ApiRequest.request(reqPath, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.tableItems = response.data;
          self.paging = response.paging;
          self.loading = false;
        }
      });
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    }
  },
  mounted () {
    this.getTableData();
  }
}
